import React from "react";
import { toast } from "react-toastify";

import Modal from "../../../../components/Reusable/Modal";
import { Button } from "../../../../components/Reusable/Button";
import { DeleteModalProps } from "../types";
import { useAppDispatch, useAppSelector } from "../../../../hooks/hooks";
import {
  deleteDGCoinCategory,
  fetchDGCoinCategories,
} from "../../../../features/auth/store/dgcoinCategorySlice";

export const DeleteDGCoinCategoryModal: React.FC<DeleteModalProps> = ({
  id,
  isOpen,
  onClose,
}) => {
  const dispatch = useAppDispatch();
  const { currentPage } = useAppSelector((state) => state.dgcoinCategories);

  const handleDelete = async () => {
    if (!id) return;
    try {
      await dispatch(deleteDGCoinCategory(id)).unwrap();
      toast.success("DG Coin category deleted successfully!");
      dispatch(fetchDGCoinCategories({ page: currentPage }));
      onClose();
    } catch (error: any) {
      toast.error(error?.message || "Failed to delete DG Coin category");
      console.error("Delete error:", error);
    }
  };

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="bg-white p-6 w-[400px] dark:bg-black dark:text-white">
        <p className="text-base font-semibold mb-4">
          Are you sure you want to delete this DG Coin category?
        </p>
        <div className="flex justify-end gap-2">
          <Button
            onClick={onClose}
            bgColor="bg-gray-200"
            textColor="text-gray-700"
            borderRadius="rounded-lg"
            className="px-4 py-2"
          >
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            bgColor="bg-red-500"
            textColor="text-white"
            borderRadius="rounded-lg"
            className="px-4 py-2"
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};
